/**
 * Signature rows — the Ticket section's driver signature and the Delivery section's signature — always
 * render as the last standard row of their section, just before the custom fields, regardless of
 * stored `order`: the Template Editor gives them no drag handle and nothing can be dropped below
 * them; the web Delivery table puts its column last, and the web ticket detail renders the driver
 * signature in its own block.
 */
export const SIGNATURE_FIELD_KEYS = new Set<string>(['ticketDriverSignature', 'deliverySignature'])

/** Whether a field key is a signature key. */
export const isSignatureField = (key: string): boolean => SIGNATURE_FIELD_KEYS.has(key)
